import type { AxiosInstance } from 'axios';

/**
 * Ref to the API client instance. Set by client.ts after creation so AuthService
 * can use it without creating a circular dependency (client → interceptors → AuthService → client).
 */
let apiClientInstance: AxiosInstance | null = null;

export function setApiClient(instance: AxiosInstance): void {
  apiClientInstance = instance;
}

export function getApiClient(): AxiosInstance | null {
  return apiClientInstance;
}
